import React, { useEffect, useState } from "react";
import { CustomLabel, HeaderDivider } from "../../../../../utilities/utll";
import { Button, Checkbox, Input, Select, Tooltip } from "antd";
import { CheckCircleFilled, QuestionCircleOutlined } from "@ant-design/icons";
import { Col, Row } from "reactstrap";
import { useCommercialStore } from "../../../../../store/vendorRegistrationStore/useCommercialStore";
import { useBasicDataFormStore } from "../../../../../store/vendorRegistrationStore/useBasicDataFormStore";
import ApproveReject from "../../../../../components/approveReject/ApproveReject";
import { useVendorMasterStore } from "../../../../../store/useVendorMasterStore";
import LuxuryCheckbox from "../../../../../common/Checkbox";

export const CommercialForm = () => {
  const { commercialForm, handleInputChange, errors } = useCommercialStore();
  const {
    businessType,
    getBusinessType,
    checkBoxes,
    setCheckbox,
    vendorDetailByGuid,
  } = useVendorMasterStore();
  const showStep4 = localStorage.getItem("ShowStep4") === "Yes";

  const { basicData } = useBasicDataFormStore();
  // const businessType = ["OUTRIGHT", "SOR", "SIS"];
  const payment = ["WIRE TRANSFER (RTGS)"];
  const period = ["Monthly", "Quaterly", "Half-Yearly", "Yearly"];
  const Fright = ["Agree", "DisAgree"];
  const taxType = ["CST", "VAT"];
  const accountReconcil = ["Yes", "No"];
  const submitted = localStorage.getItem("submitted") === "Yes";
  const GUID = localStorage.getItem("vendorGUID") || "";
  const approve = localStorage.getItem("showApprove") === "true";
  const { VendorType } = vendorDetailByGuid?.Vendor || {};

  useEffect(() => {
    getBusinessType();
  }, []);

  useEffect(() => {
    handleInputChange("locationCode", basicData.locationCode);
    handleInputChange("vendorGUID", GUID);
  }, [basicData.locationCode, GUID]);

  const allChecked = Object.values(checkBoxes).every(Boolean);

  const handleBusinessTypeChange = (selectedType) => {
    // Set business type
    handleInputChange("businessType", selectedType);

    // Find matching object
    const selectedObj = businessType.find(
      (item) => item.BusinessType === selectedType,
    );

    // Set agreed credit days automatically
    handleInputChange(
      "agreedCreditDays",
      selectedObj ? selectedObj.NoOfDays : "",
    );
  };
  return (
    <>
      <HeaderDivider title="Credit Terms" isShort />
      <Row style={{ marginTop: "20px" }}>
        {VendorType !== "ZAEX" && (
          <Col xl={3} lg={3} md={6}>
            <CustomLabel children={"Business Type"} isImportnt={true} />
            <Select
              placeholder="Select Business Type"
              allowClear
              showSearch
              optionFilterProp="label"
              size="medium"
              style={{ width: "100%" }}
              options={businessType.map((item) => ({
                label: item?.BusinessType,
                value: item?.BusinessType,
              }))}
              value={commercialForm?.businessType}
              onChange={(val) => handleBusinessTypeChange(val)}
              disabled={submitted}
            />
            {errors?.businessType && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.businessType}
              </span>
            )}
          </Col>
        )}

        <Col xl={3} lg={3} md={6}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "flex", flexDirection: "column" }}>
              <CustomLabel children={"Agreed Credit Days"} isImportnt={true} />
              <Input
                type="text"
                placeholder="Enter Agreed Credit Days"
                size="medium"
                value={commercialForm.agreedCreditDays}
                onChange={(e) => {
                  const value = e.target.value;

                  // Allow only positive integers (including empty)
                  if (/^\d*$/.test(value))
                    handleInputChange("agreedCreditDays", e.target.value);
                }}
                disabled={submitted}
              />
            </span>
            <Tooltip title="Agreed Credit Days">
              <span style={{ marginTop: "1.35rem", marginLeft: "10px" }}>
                <Button icon={<QuestionCircleOutlined />} />
              </span>
            </Tooltip>
          </div>
          {errors?.agreedCreditDays && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.agreedCreditDays}
            </span>
          )}
        </Col>
        <Col xl={3} lg={3} md={6}>
          <CustomLabel children={"Return Allowed Ind"} isImportnt={true} />
          <Select
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            options={accountReconcil.map((t) => ({
              label: t,
              value: t === "Yes" ? true : false,
            }))}
            value={commercialForm.returnAllowIndicator}
            onChange={(val) => handleInputChange("returnAllowIndicator", val)}
            disabled={submitted}
          />
          {errors?.returnAllowIndicator && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.returnAllowIndicator}
            </span>
          )}
        </Col>
        <Col xl={3} lg={3} md={6}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "flex", flexDirection: "column" }}>
              <CustomLabel
                children={"Lead Time"}
                isImportnt={VendorType === "ZAEX" ? false : true}
              />
              <Input
                type="text"
                placeholder="Enter Lead Time"
                size="medium"
                value={commercialForm.leadTime}
                onChange={(e) => {
                  const value = e.target.value;

                  // Allow only positive integers (including empty)
                  if (/^\d{0,10}$/.test(value)) {
                    handleInputChange("leadTime", value);
                  }
                }}
                disabled={submitted}
              />
            </span>
            <Tooltip title="Lead Time">
              <span style={{ marginTop: "1.35rem", marginLeft: "10px" }}>
                <Button icon={<QuestionCircleOutlined />} />
              </span>
            </Tooltip>
          </div>
          {errors?.leadTime && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.leadTime}
            </span>
          )}
        </Col>
      </Row>
      <Row>
        {VendorType !== "ZAEX" && (
          <>
            <Col xl={3} lg={3} md={6}>
              <div style={{ display: "flex" }}>
                <span style={{ display: "flex", flexDirection: "column" }}>
                  <CustomLabel children={"In Days SOR"} isImportnt={false} />
                  <Input
                    type="text"
                    placeholder="Enter In Days SOR"
                    size="medium"
                    value={commercialForm.inDaysSOR}
                    onChange={(e) => {
                      const value = e.target.value;

                      // Allow only positive integers (including empty)
                      if (/^\d{0,10}$/.test(value))
                        handleInputChange("inDaysSOR", e.target.value);
                    }}
                    disabled={submitted}
                  />
                </span>
                <Tooltip title="In Days SOR">
                  <span style={{ marginTop: "1.35rem", marginLeft: "10px" }}>
                    <Button icon={<QuestionCircleOutlined />} />
                  </span>
                </Tooltip>
              </div>
            </Col>

            <Col xl={3} lg={3} md={6} sm={12}>
              <CustomLabel children={"Discount %"} isImportnt={false} />
              <Input
                type="text"
                placeholder="Enter Discount %"
                size="medium"
                value={commercialForm.discountPercent}
                onChange={(e) => {
                  const value = e.target.value;

                  // Allow only positive integers (including empty)
                  if (/^\d{0,10}$/.test(value))
                    handleInputChange("discountPercent", e.target.value);
                }}
                disabled={submitted}
              />
            </Col>
            <Col xl={3} lg={3} md={6} sm={12}>
              <CustomLabel children={"No of Days earlier"} isImportnt={false} />
              <Input
                type="text"
                placeholder="Enter No of Days earlier"
                size="medium"
                value={commercialForm.noOfDaysEarlier}
                onChange={(e) => {
                  const value = e.target.value;

                  // Allow only positive integers (including empty)
                  if (/^\d{0,10}$/.test(value))
                    handleInputChange("noOfDaysEarlier", e.target.value);
                }}
                disabled={submitted}
              />
            </Col>
          </>
        )}
        {submitted && showStep4 && (
          <Col
            xl={3}
            lg={3}
            md={6}
            sm={12}
            style={{
              marginTop: 20,
            }}
          >
            <LuxuryCheckbox
              id={"creditTerms"}
              label="Checked"
              checked={checkBoxes.creditTerms}
              onChange={(e) =>
                setCheckbox("creditTerms", !checkBoxes.creditTerms)
              }
              disabled={!approve}
            />
          </Col>
        )}
      </Row>
      <HeaderDivider title="Payment Instruction And Method" isShort />
      <Row style={{ marginTop: "20px" }}>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"In Favour of"} isImportnt={true} />
          <Input
            type="text"
            placeholder="Enter In Favour of"
            size="medium"
            value={commercialForm.inFavourOf}
            // onChange={(e) => handleInputChange("inFavourOf", e.target.value)}
            onChange={(e) => handleInputChange("inFavourOf", e.target.value)}
            disabled={submitted}
          />
          {errors?.inFavourOf && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.inFavourOf}
            </span>
          )}
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"Bank Name"} isImportnt={true} />
          <Input
            type="text"
            placeholder="Enter Bank Name"
            size="medium"
            value={commercialForm.bankName}
            onChange={(e) => {
              {
                const value = e.target.value;
                // Allow only letters and spaces
                if (/^[A-Za-z\s]*$/.test(value)) {
                  handleInputChange("bankName", value);
                }
              }
            }}
            disabled={submitted}
          />
          {errors?.bankName && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.bankName}
            </span>
          )}
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"Branch Name"} isImportnt={true} />
          <Input
            type="text"
            placeholder="Enter Branch Name"
            size="medium"
            value={commercialForm.branchName}
            // onChange={(e) => handleInputChange("branchName", e.target.value)}
            onChange={(e) => {
              {
                const value = e.target.value;
                // Allow letters, digits, and spaces23
                if (/^[A-Za-z0-9\s]*$/.test(value)) {
                  handleInputChange("branchName", value);
                }
              }
            }}
            disabled={submitted}
          />
          {errors?.branchName && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.branchName}
            </span>
          )}
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"Account No"} isImportnt={true} />
          <Input
            type="text"
            placeholder="Enter Account No"
            size="medium"
            value={commercialForm.accountNo}
            onChange={(e) => {
              const value = e.target.value;

              // Allow digits only
              if (/^[a-zA-Z0-9]*$/.test(value)) {
                handleInputChange("accountNo", value);
              }
            }}
            disabled={submitted}
          />
          {errors?.accountNo && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.accountNo}
            </span>
          )}
        </Col>
      </Row>
      <Row>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"IFSC Code"} isImportnt={true} />
          <Input
            type="text"
            placeholder="Enter IFSC Code"
            size="medium"
            value={commercialForm.ifscCode}
            onChange={(e) => handleInputChange("ifscCode", e.target.value)}
            disabled={submitted}
          />
          {errors?.ifscCode && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.ifscCode}
            </span>
          )}
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"Payment Method"} isImportnt={true} />
          <Select
            placeholder="Select Payment Method"
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            options={payment.map((t) => ({
              label: t,
              value: t,
            }))}
            value={commercialForm.paymentMethod}
            onChange={(val) => handleInputChange("paymentMethod", val)}
            disabled={submitted}
          />
          {errors?.paymentMethod && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.paymentMethod}
            </span>
          )}
        </Col>
        {submitted && showStep4 && (
          <Col
            xl={3}
            lg={3}
            md={6}
            sm={12}
            style={{
              marginTop: 20,
            }}
          >
            <LuxuryCheckbox
              id={"paymentInsAndMethods"}
              label="Checked"
              checked={checkBoxes.paymentInsAndMethods}
              onChange={(e) =>
                setCheckbox(
                  "paymentInsAndMethods",
                  !checkBoxes.paymentInsAndMethods,
                )
              }
              disabled={!approve}
            />
          </Col>
        )}
      </Row>
      {VendorType !== "ZAEX" && (
        <>
          <HeaderDivider title="Account Reconciliation" isShort />
          <Row style={{ marginTop: "20px" }}>
            <Col xl={2} lg={4} md={6} sm={12}>
              <CustomLabel
                children={"Any Municipal Tax(LBT/OCTROI)"}
                isImportnt={false}
              />
              <Select
                placeholder="Select "
                allowClear
                showSearch
                optionFilterProp="label"
                size="medium"
                style={{ width: "100%" }}
                options={accountReconcil.map((t) => ({
                  label: t,
                  value: t,
                }))}
                value={commercialForm.anyMunicipalTax}
                onChange={(val) => handleInputChange("anyMunicipalTax", val)}
                disabled={submitted}
              />
            </Col>
            <Col xl={2} lg={4} md={6} sm={12}>
              <CustomLabel
                children={"Replenishment Approval Ind"}
                isImportnt={false}
              />
              <Select
                placeholder="Select"
                allowClear
                showSearch
                optionFilterProp="label"
                size="medium"
                style={{ width: "100%" }}
                options={accountReconcil.map((t) => ({
                  label: t,
                  value: t === "Yes" ? true : false,
                }))}
                value={commercialForm.replenishmentApprovalIndicator}
                onChange={(val) =>
                  handleInputChange("replenishmentApprovalIndicator", val)
                }
                disabled={submitted}
              />
            </Col>
            {VendorType !== "ZAEX" && (
              <Col xl={2} lg={4} md={6} sm={12}>
                <CustomLabel
                  children={"Account Reconciliation Period"}
                  isImportnt={false}
                />
                <Select
                  id="roletype"
                  placeholder="Select "
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  size="medium"
                  style={{ width: "100%" }}
                  options={period.map((t) => ({
                    label: t,
                    value: t,
                  }))}
                  value={commercialForm.accountReconciliationPeriod}
                  onChange={(val) =>
                    handleInputChange("accountReconciliationPeriod", val)
                  }
                  disabled={submitted}
                />
              </Col>
            )}

            <Col xl={2} lg={4} md={6} sm={12}>
              <CustomLabel children={"Freight Terms"} isImportnt={false} />
              <Select
                id="roletype"
                placeholder="Select "
                allowClear
                showSearch
                optionFilterProp="label"
                size="medium"
                style={{ width: "100%" }}
                options={Fright.map((t) => ({
                  label: t,
                  value: t,
                }))}
                value={commercialForm.freightTerms}
                onChange={(val) => handleInputChange("freightTerms", val)}
                disabled={submitted}
              />
            </Col>
            <Col xl={2} lg={4} md={6} sm={12}>
              <CustomLabel
                children={"Tax Payer Type(CST/VAT"}
                isImportnt={false}
              />
              <Select
                id="roletype"
                placeholder="Select "
                allowClear
                showSearch
                optionFilterProp="label"
                size="medium"
                style={{ width: "100%" }}
                options={taxType.map((t) => ({
                  label: t,
                  value: t,
                }))}
                value={commercialForm.taxPayerType}
                onChange={(val) => handleInputChange("taxPayerType", val)}
                disabled={submitted}
              />
            </Col>
            <Col xl={2} lg={4} md={6} sm={12}>
              <CustomLabel children={"DSD Indicator"} isImportnt={false} />
              <Select
                id="roletype"
                placeholder="Select "
                allowClear
                showSearch
                optionFilterProp="label"
                size="medium"
                style={{ width: "100%" }}
                options={accountReconcil.map((t) => ({
                  label: t,
                  value: t === "Yes" ? true : false,
                }))}
                value={commercialForm.dsdIndicator}
                onChange={(val) => handleInputChange("dsdIndicator", val)}
                disabled={submitted}
              />
            </Col>
          </Row>
        </>
      )}
      {submitted && approve && <ApproveReject checked={allChecked} />}
    </>
  );
};
